import React from 'react'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import UserAvatarWithStats from 'app/components/UserAvatarWithStats/UserAvatarWithStats'
import './styles.scss'

const bc = 'user-protrack-done-commit-details'

const UserProtrackDoneCommitDetails = ({ t, completedCount, avatar, initials, proTrackLevelProgress, streakMax }) => {
  return (
    <div className={`${bc}__wrapper`}>
      <UserAvatarWithStats
        isProtrackPopup
        avatar={avatar}
        initials={initials}
        proTrackProgress={proTrackLevelProgress}
        streakCurrent={streakMax}
        circleProps={{
          cx: 37,
          cy: 37,
          strokeWidth: 4,
          r: 35,
        }}
      />
      <div className={`${bc}__stats`}>
        <span className={cn(`${bc}__stats--current`, { [`${bc}__stats--no-streak`]: !completedCount })}>
          {completedCount}
        </span>
        <div className={`${bc}__stats--title`}>{t('Activities Completed')}</div>
      </div>
    </div>
  )
}

export default withTranslation('user')(UserProtrackDoneCommitDetails)
